import { authApi, type GetSessionInfoResponse } from "@b2bportal/auth-api";
import { axiosInstance } from "@hopper-b2b/api";

export const sessionInfoPost = async () => {
  try {
    const response = await authApi(axiosInstance).apiV0AuthSessionInfoPost();
    return response.data;
  } catch (error) {
    console.error("Create session error:", error);
    throw Error("Create session error");
  }
};

export const getSession = (): Promise<GetSessionInfoResponse> =>
  // eslint-disable-next-line no-async-promise-executor
  new Promise(async (resolve, reject) => {
    try {
      const response = await sessionInfoPost();
      resolve(response);
    } catch (e) {
      reject(e);
    }
  });
export default getSession;
